import { ObjetKStatusCode } from '@siclop/kstone-vue'

/** Équipe nommée (T55) : des salariés et un ou plusieurs responsables, qui approuvent leurs congés. */
export class Team extends ObjetKStatusCode {
  description: string = ''
  /** Sur-validation des congés des membres : null = selon l'entreprise, true / false = forcé pour l'équipe. */
  secondLevelApproval: boolean | null = null

  constructor(data?: Partial<Team>) {
    super(data)
    if (data) {
      this.description = data.description ?? ''
      this.secondLevelApproval = typeof data.secondLevelApproval === 'boolean' ? data.secondLevelApproval : null
    }
  }
}

/** Membre d'une équipe ; `isManager` : responsable de l'équipe. */
export interface TeamMember {
  id: number
  teamId: number
  employeeId: number
  isManager: boolean
}
